/**
 * league.country + league.name → flagcdn code (single entry point for create + fixtures).
 */

import {
  EU_LEAGUE_NAME_SUBSTRINGS,
  LEAGUE_COUNTRY_NAME_TO_FLAG_CODE,
  LEAGUE_DISPLAY_NAME_TO_FLAG_CODE,
} from '../constants/leagueCountryToFlagCode.constants';
import { normalizeCountryCodeForFlagCdn } from '../../worldcup/helpers/flagCdn.helper';

function normKey(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ');
}

function flagFromCountry(country: string | undefined | null): string | null {
  if (country == null || typeof country !== 'string') return null;
  const trimmed = country.trim();
  if (!trimmed) return null;

  const key = normKey(trimmed);
  const mapped = (LEAGUE_COUNTRY_NAME_TO_FLAG_CODE as Record<string, string>)[key];
  if (mapped === 'xx') return null;
  if (mapped) return normalizeCountryCodeForFlagCdn(mapped);
  if (/^[a-zA-Z]{2}$/.test(trimmed)) return normalizeCountryCodeForFlagCdn(trimmed);
  return null;
}

function flagFromLeagueName(name: string): string | null {
  const n = normKey(name);
  if (!n) return null;

  const exactDisplay = LEAGUE_DISPLAY_NAME_TO_FLAG_CODE[n];
  if (exactDisplay) return normalizeCountryCodeForFlagCdn(exactDisplay);

  const eu = normalizeCountryCodeForFlagCdn('eu');
  if (!eu) return null;
  for (const s of EU_LEAGUE_NAME_SUBSTRINGS) {
    if (n.includes(s)) return eu;
  }
  if (n.includes('belgian') || n.includes('jupiler')) return normalizeCountryCodeForFlagCdn('be');
  if (n.includes('saudi') || n.includes('roshn')) return normalizeCountryCodeForFlagCdn('sa');
  return null;
}

/** Prefer country; if missing or World, infer from league name (UEFA → EU, Saudi → SA, etc.). */
export function resolveLeagueCountryCodeForFlag(
  countryName: string | undefined | null,
  leagueName: string | undefined | null
): string | null {
  const fromCountry = flagFromCountry(countryName);
  if (fromCountry) return fromCountry;
  if (leagueName == null || typeof leagueName !== 'string') return null;
  const t = leagueName.trim();
  return t ? flagFromLeagueName(t) : null;
}
